module.exports = __webpack_public_path__ + "static/media/acura-logo-white.b5ddecff.svg";